import { useInitChatOnOngoingConversationEffect } from "@faire/help-center-self-serve/chat/hooks/useInitChatOnOngoingConversationEffect";
import { useAIChatbotAccess } from "@faire/help-center-self-serve/hooks/useAIChatbotAccess";
import { SelfServeBase } from "@faire/help-center-self-serve/SelfServeBase";
import { isLoggedInBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { Route } from "@faire/web--source/ui/routing/Route";
import { Switch } from "@faire/web--source/ui/routing/Switch";
import home, {
  route as homeRoute,
  QueryParameters as SupportQueryParameters,
} from "@faire/web-api--source/routes/support";
import { route as articleRoute } from "@faire/web-api--source/routes/support/articles/articleId";
import { route as brandsRoute } from "@faire/web-api--source/routes/support/brands";
import { route as dsaFormRoute } from "@faire/web-api--source/routes/support/dsa";
import { route as popularGuideRoute } from "@faire/web-api--source/routes/support/popular-guides/categoryId";
import { route as retailersRoute } from "@faire/web-api--source/routes/support/retailers";
import { route as searchRoute } from "@faire/web-api--source/routes/support/search";
import { route as selfServeRoute } from "@faire/web-api--source/routes/support/self-serve";
import { route as topicRoute } from "@faire/web-api--source/routes/support/topics/topicId";
import React from "react";
import { Redirect } from "react-router-dom";

import { useDecagon } from "./hooks/chatbot/decagon/useDecagon";
import { LazyArticlePage } from "./views/articles/LazyArticlePage";
import { LazyBrandsHome } from "./views/brands/LazyBrandsHome";
import { LazyDsaForm } from "./views/dsa-form/LazyDsaForm";
import { LazyPopularGuidesPage } from "./views/popular-guides/LazyPopularGuidesPage";
import { LazyRetailersHome } from "./views/retailers/LazyRetailersHome";
import { LazySearchPage } from "./views/search/LazySearchPage";
import { LazyTopicPage } from "./views/topic/LazyTopicPage";

export const AppRoutes: React.FC = () => {
  const {
    faire_direct_widget_chat,
    trigger_va,
    trigger_order_va,
    brand_order_token,
  } = useQueryParams(SupportQueryParameters.parse);
  useInitChatOnOngoingConversationEffect();
  useDecagon();
  const { hasAIChatbotAccess } = useAIChatbotAccess();

  const LandingPage = () => {
    if (isLoggedInBrand()) {
      return LazyBrandsHome;
    } else {
      return LazyRetailersHome;
    }
  };

  return (
    <Switch>
      <Route exact path={homeRoute} component={LandingPage()} />
      <Route path={brandsRoute} component={LazyBrandsHome} />
      <Route path={retailersRoute} component={LazyRetailersHome} />
      <Route path={searchRoute} component={LazySearchPage} />
      <Route path={popularGuideRoute} component={LazyPopularGuidesPage} />
      <Route path={topicRoute} component={LazyTopicPage} />
      <Route path={articleRoute} component={LazyArticlePage} />
      {hasAIChatbotAccess ? null : (
        <Route path={selfServeRoute} component={SelfServeBase} />
      )}
      <Route path={dsaFormRoute} component={LazyDsaForm} />

      <Redirect
        path={`${homeRoute}/contact**`}
        to={`${homeRoute}?contact=true`}
      />
      <Redirect
        to={home({
          faire_direct_widget_chat,
          trigger_va,
          trigger_order_va,
          brand_order_token,
        })}
      />
    </Switch>
  );
};
